module.exports = __webpack_public_path__ + "img/qbert_questions_p9.71cb66ac.jpg";